import { styled } from '@mui/material';
import { ReactNode } from 'react';

const StyledSubheader = styled('header')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const StyledSubtitle = styled('h2')<{ variant?: 'secondary' }>(
  ({ variant }) => ({
    fontWeight: variant === 'secondary' ? 400 : 700,
    fontSize: 16,
    lineHeight: 1.5,
    margin: 0,
    color:
      variant === 'secondary'
        ? 'var(--text-text-secondary-color)'
        : 'var(--text-text-primary-color)',
  })
);

export type SubheaderProps = {
  title: string;
  action?: ReactNode;
  variant?: 'secondary';
};

export const Subheader = ({ title, action, variant }: SubheaderProps) => {
  return (
    <StyledSubheader>
      <StyledSubtitle variant={variant}>{title}</StyledSubtitle>
      {action}
    </StyledSubheader>
  );
};
